const imprintFragmentShader = /* glsl */ `
precision highp float;

varying vec2 vUv;

uniform sampler2D uPrevious;
uniform vec2 uBallPosition;
uniform float uBallRadius;
uniform float uStrength;

void main() {
  float previous = texture2D(uPrevious, vUv).r;
  float distanceToBall = distance(vUv, uBallPosition);

  float imprint =
    1.0 - smoothstep(0.0, uBallRadius, distanceToBall);

  float height = max(previous, imprint * uStrength);

  gl_FragColor = vec4(height, height, height, 1.0);
}
`;

export default imprintFragmentShader;
